import { forwardRef } from "react";
import { Mui, MuiIcons } from "@osu/react-ui";
import { mergeSxStyles } from "../../../../styles/util";

const deleteButtonSx = {
  [`&.${Mui.buttonBaseClasses.root}.${Mui.iconButtonClasses.root}.${Mui.buttonBaseClasses.disabled}`]:
    {
      pointerEvents: "none",
    },
};

const Disabled = forwardRef(({ sx }, ref) => (
  <Mui.IconButton
    ref={ref}
    sx={mergeSxStyles(sx, deleteButtonSx)}
    disabled
    aria-disabled="true"
  >
    <MuiIcons.DeleteForever />
  </Mui.IconButton>
));

const DeleteAction = forwardRef(({ disabled, sx, ...rest }, removeRef) => {
  return (
    <Mui.Box
      sx={
        disabled
          ? {
              cursor: "not-allowed",
            }
          : {}
      }
    >
      {disabled ? (
        <Disabled />
      ) : (
        <Mui.Tooltip
          title={"Remove from list"}
        >
          <Mui.IconButton
            ref={removeRef}
            sx={sx}
            {...rest}
          >
            <MuiIcons.DeleteForever />
          </Mui.IconButton>
        </Mui.Tooltip>
      )}
    </Mui.Box>
  );
});

export default DeleteAction;
